export default function possible11DigitsTo10(phNum) {
  return phNum.substring(phNum.length - 10);
}
